import { useState } from 'react';

// Mostra la password temporanea una sola volta: dopo la chiusura non è più recuperabile.
export default function PasswordTemporanea({ email, password, onChiudi }) {
  const [copiata, setCopiata] = useState(false);

  const copia = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopiata(true);
    } catch {
      setCopiata(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={{ marginTop: 0 }}>Password temporanea</h3>
        <p style={styles.testo}>Comunica all'azienda queste credenziali. Al primo accesso dovrà scegliere una nuova password.</p>
        <div style={styles.riga}><span style={styles.etichetta}>Email</span><span>{email}</span></div>
        <div style={styles.riga}>
          <span style={styles.etichetta}>Password</span>
          <code style={styles.codice}>{password}</code>
          <button type="button" onClick={copia} style={styles.btnCopia}>{copiata ? 'Copiata' : 'Copia'}</button>
        </div>
        <div style={styles.avviso}>La password viene mostrata solo ora. Se la perdi, fai un nuovo reset.</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
          <button type="button" onClick={onChiudi} style={styles.btn}>Ho preso nota, chiudi</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 },
  modal: { background: 'white', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '480px', margin: '0 1rem' },
  testo: { color: '#555', fontSize: '0.9rem' },
  riga: { display: 'flex', alignItems: 'center', gap: '0.6rem', margin: '0.6rem 0', flexWrap: 'wrap' },
  etichetta: { width: '80px', fontSize: '0.8rem', color: '#777', fontWeight: 600, textTransform: 'uppercase' },
  codice: { fontFamily: 'monospace', fontSize: '1.1rem', background: '#F7F7EA', padding: '0.3rem 0.6rem', borderRadius: '4px', letterSpacing: '0.05em' },
  btnCopia: { background: '#eef', color: '#232323', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' },
  avviso: { background: '#fff8e1', color: '#7a5b00', padding: '0.6rem', borderRadius: '6px', fontSize: '0.85rem', marginTop: '1rem' },
  btn: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
};
